module.exports = __webpack_public_path__ + "static/img/gpt62.c4b4e378.jpg";